const CreateIcon = ({ color = '#364153', width = '16px', height = '16px' }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M3.33301 8H12.6663" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M8 3.33203V12.6654" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};

export default CreateIcon;

